
export interface FindAllCompanyResponseDTO {
    total: number
    page: number
    perPage: number
    prev: boolean
    next: boolean
    totalPage: number
    data: CompanyDTO[]
}

export interface CompanyDTO {
    name: string
    surname: string
    email: string
    phoneNumber: string
    fiscalCode: string
    userId: string
    id: string
    companyName: string
    administrativeCompanies: string[]
    financialAdvisor: string
    collaborators: string[]
    note: string
    avatarObjectId: string
    vat: string
    acubeAccounts: string[]
    primaryColor: string
    status: CompanyStatus
    isActive: boolean
}

export interface CompanyFiltersDTO {
    itemsPerPage: number
    order: boolean
    page: number
    sort: string
    companyName: string
    financialAdvisorId: string
    status: CompanyStatus | string
}

export interface CreateCompanyRequestDTO {
    name: string
    surname: string
    email: string
    fiscalCode: string
    phoneNumber: string
    companyName: string
    administrativeCompanyId: number
    financialAdvisorId: number
    collaboratorId: number
    note: string
    avatar: File | null
    vat: string
    status: CompanyStatus
}

export interface EditCompanyRequestDTO {
    name: string
    surname: string
    phoneNumber: string
    companyName: string
    note: string
    avatar: File | null
}

export enum CompanyStatus {
    ACTIVE = "ACTIVE",
    SUSPENDED = "SUSPENDED"
}

export const tabOperationMap = {
    0: ["Aziende", "Overview"],
    1: ["Aziende", "Documenti"],
    2: ["Aziende", "Messaggi"],
    3: ["Aziende", "Conto corrente"],
    4: ["Aziende", "Calendario"],
};

export const tabOperationCompanyMap = {
    0: ["Documenti", "Bilanci e Dichiarativi"],
    1: ["Documenti", "F24"],
    2: ["Documenti", "Dipendenti"],
    3: ["Documenti", "Contabili"],
    4: ["Documenti", "Altro"],
};

export const tabSettingMap = {
    0: ["Aziende", "Impostazioni azienda", "Anagrafica"],
    1: ["Aziende", "Impostazioni azienda", "Referenti"],
    2: ["Aziende", "Impostazioni azienda", "Ruoli"],
};

export const tabSettingCompanyMap = {
    0: ["Impostazioni", "Anagrafica"],
    1: ["Impostazioni", "Referenti"],
    3: ["Impostazioni", "Conto corrente"],
};

export const companyStatusMap = new Map<CompanyStatus, string>([
    [CompanyStatus.ACTIVE, 'Attiva'],
    [CompanyStatus.SUSPENDED, 'Archiviata'],
])
